<template>
    <div>
        <switch-currency-confirmation-modal></switch-currency-confirmation-modal>
        <select class="form-select currencySelect" aria-label="Currency select" v-model="selected_currency" @change="switchCurrency">
            <switch-currency v-for="c in all_currencies" :shortcut="c.currency_shortcut" :value="c.currency_shortcut" :selected="c.is_default === 1"></switch-currency>
        </select>
    </div>
</template>

<script>
import axios from "axios";
import {inject, onMounted, reactive, toRefs} from "vue";
import SwitchCurrencyConfirmationModal from "../modals/SwitchCurrencyConfirmationModal";
import SwitchCurrency from "../buttons/SwitchCurrency";

export default {

    props: ['allCurrencies', 'selectedCurrency'],

    components: {
        SwitchCurrencyConfirmationModal,
        SwitchCurrency,
    },

    setup(props) {

        let all_currencies = props.allCurrencies

        const state = reactive({
            show: false,
            escToClose: true,
            csrf: null,
            currency: null,
            currencies: null,
            selected_currency: null,
        })

        const emitter = inject('emitter')

        onMounted( () => {
            //getCurrency("true");
            //getCurrency("false");
            //setCurrency();
            state.selected_currency = props.selectedCurrency.shortcut
        })

        /*function getCurrency(all) {
            axios.get('/getCurrency', {
                params: {
                    all: all
                }
            }).then( response => {
                if (all == "true") {
                    state.currencies = response.data;
                } else {
                    state.currency = response.data;
                }
            }).catch( error => console.error(error) )
        }*/

        /*function getCurrency() {
            axios.get('/getCurrency')
                .then( response => {
                    state.currency = response.data;
                })
                .catch( error => console.error(error) )
        }*/

        function switchCurrency() {
            emitter.emit('switch-currency-confirmation-modal', state.selected_currency)
        }

        return {
            switchCurrency,
            ...toRefs(state),
            all_currencies,
        }
    }
}
</script>
